meedy.factory('meedy.invoiceModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.invoiceService',
    function($rootScope, applicationModel, baseModel, invoiceService) {

        function InvoiceModel() {

            var self = this;

            this.getInvoices = function(criteria) {
                invoiceService.getInvoices(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_INVOICES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_INVOICES.ERROR, error);
                    }
                )
            };

            this.getDownloadToken = function(idInvoice, fileType) {
                self.fileType = fileType;
                invoiceService.getDownloadToken(idInvoice, fileType).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_DOWNLOAD_TOKEN.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_DOWNLOAD_TOKEN.ERROR, error);
                    }
                )
            };

            this.getInvoicesWaitingForAcceptation = function() {
                invoiceService.getInvoicesWaitingForAcceptation().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_INVOICES_WAITING_FOR_ACCEPTATION.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.GET_INVOICES_WAITING_FOR_ACCEPTATION.ERROR, error);
                    }
                )
            };

            this.updateInvoice = function(invoice) {
                applicationModel.actionInProgress = true;
                invoiceService.updateInvoice(invoice).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.UPDATE_INVOICE.SUCCESS, dataPage);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.UPDATE_INVOICE.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.download = function(token) {
                invoiceService.download(token, self.fileType).then(
                    function (dataPage) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.DOWNLOAD.SUCCESS, dataPage);
                    },
                    function(error) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.INVOICE.DOWNLOAD.ERROR, error);
                    }
                )
            };

        }

        return new InvoiceModel();
    }
]);
